<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6" md="8">
        <v-btn
          v-if="currentPermission.privilegeLevel == 'admin' || isSuperUser"
          class="pa-5"
          rounded
          color="primary"
          @click="handleInviteNewClick"
          elevation="0"
        >
          <v-icon left>mdi-account-plus</v-icon> Invite New
        </v-btn>
        <v-dialog eager v-model="addEditDialog" max-width="500px" persistent>
          <v-card>
            <v-card-title class="justify-space-between">
              {{
                selectedBusinessPortalUser.documentId != ""
                  ? "Edit Access Details"
                  : "Invite New User"
              }}
              <v-btn fab text small @click="addEditDialog = false"
                ><v-icon class="text-right text--secondary"
                  >close</v-icon
                ></v-btn
              >
            </v-card-title>
            <v-card-subtitle v-if="selectedBusinessPortalUser.documentId == ''">
              Provide another team member access to the Pappyon business portal
            </v-card-subtitle>
            <v-card-text class="py-0">
              <v-form ref="addEditAccessForm">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" xl="4" class="pt-0">
                      <v-text-field
                        validate-on-blur
                        :rules="nameRules"
                        label="First Name"
                        required
                        outlined
                        dense
                        v-model="selectedBusinessPortalUser.firstName"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" xl="4" class="pt-0">
                      <v-text-field
                        validate-on-blur
                        :rules="nameRules"
                        label="Last Name"
                        required
                        outlined
                        dense
                        v-model="selectedBusinessPortalUser.lastName"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pt-0">
                      <v-text-field
                        validate-on-blur
                        :readonly="selectedBusinessPortalUser.documentId != ''"
                        :rules="
                          selectedBusinessPortalUser.documentId != ''
                            ? []
                            : emailRules
                        "
                        label="Email"
                        required
                        outlined
                        dense
                        v-model="selectedBusinessPortalUser.email"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pt-0">
                      <v-select
                        :rules="nameRules"
                        outlined
                        dense
                        v-model="selectedBusinessPortalUser.privilegeLevel"
                        :items="privilegeLevelOptions"
                        item-text="text"
                        item-value="value"
                        label="Privilege Level"
                        :menu-props="{ offsetY: true }"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pt-0">
                      <v-btn
                        v-if="selectedBusinessPortalUser.documentId != ''"
                        large
                        elevation="0"
                        color="primary"
                        block
                        @click="updateBusinessPortalAccessDetails()"
                      >
                        Update
                      </v-btn>
                      <v-btn
                        v-else
                        large
                        elevation="0"
                        color="primary"
                        block
                        @click="sendInvitation()"
                      >
                        Send Invitation
                      </v-btn>
                    </v-col>
                  </v-row>
                  <!-- <v-row>
                            <v-col class="pt-0">
                              <v-btn
                                  large
                                  text
                                  elevation="0"
                                  color="primary"
                                  block
                                  @click="addEditDialog = false"
                              >
                                  Cancel
                              </v-btn>
                            </v-col>
                          </v-row> -->
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          outlined
          single-line
          hide-details
          rounded
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="businessPortalUsers"
      :search="search"
    >
      <template v-slot:item.user="{ item }">
        <v-list color="transparent">
          <v-list-item>
            <UserAvatar
              :key="item.uid + item.firstName + item.lastName"
              :usersInitials="item.firstName[0] + item.lastName[0]"
              :uid="item.uid"
            />
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium">{{
                item.name
              }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.email }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip
          class="grey lighten-4 grey--text text-capitalize"
          x-small
          pill
          >{{ item.status }}</v-chip
        >
      </template>
      <template v-slot:item.privilegeLevel="{ item }">
        {{ getPrivilegeLevelDiaplyText(item.privilegeLevel) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-menu
          :key="item.documentId"
          transition="slide-y-transition"
          bottom
          left
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="item.uid != loggedInUsersUid"
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="handleEditClick(item)">
              <v-list-item-title>Edit</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="item.status == 'active'"
              @click="
                updateBusinessPortalAccessStatus(item.documentId, 'revoked')
              "
            >
              <v-list-item-title>Revoke Privilege</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="item.status == 'revoked'"
              @click="
                updateBusinessPortalAccessStatus(item.documentId, 'active')
              "
            >
              <v-list-item-title>Reinstate Privilege</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="item.status == 'invited'"
              @click="cancelInvitation(item)"
            >
              <v-list-item-title>Cancel Invitation</v-list-item-title>
            </v-list-item>
            <v-list-item v-else @click="handleRemoveClick(item)">
              <v-list-item-title>Remove</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

    <v-snackbar v-model="snackbar" left multi-line :timeout="snackbarTimeout">
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="snackbar = false"
          top
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="removeBusinessPortalUserDialog" max-width="420">
      <v-card>
        <v-card-title class="text-h6">Are you sure?</v-card-title>

        <v-card-text class="font-weight">
          Removing this record
          <span v-if="selectedBusinessPortalUser.status != 'revoked'"
            >would revoke
            <span class="font-weight-bold"
              >{{ selectedBusinessPortalUser.firstName }}'s</span
            >
            business portal access privilege and </span
          >would permanently delete any data associated with this entry.
          <v-btn
            class="mt-8 text-body-1"
            large
            elevation="0"
            color="primary"
            block
            @click="removeBusinessPortalUser()"
          >
            Remove
          </v-btn>

          <v-btn
            class="mt-2 text-body-1"
            large
            text
            elevation="0"
            color="primary"
            block
            @click="removeBusinessPortalUserDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import UserAvatar from "./UserAvatar";
import {
  addBusinessPortalAccessDoc, deleteBusinessPortalAccessDoc,
  getHttpsCallable,
  getQueryUsersCollection,
  queryBusinessPortalAccessCollection, updateBusinessPortalAccessDoc
} from "@/shared/firebase_utils";
import {onSnapshot, where} from "firebase/firestore";

export default {
  name: "BusinessPortalAccess",
  data() {
    return {
      removeBusinessPortalUserDialog: false,
      nameRules: [(v) => !!v || "This field is required"],
      privilegeLevelOptions: [
        { text: "Administrator", value: "admin" },
        { text: "Editor", value: "editor" },
        { text: "Viewer", value: "viewer" },
      ],
      snackbar: false,
      snackbarText: "",
      snackbarTimeout: 6000,
      addEditDialog: false,
      selectedBusinessPortalUser: {
        documentId: "",
        firstName: "",
        lastName: "",
        email: "",
        privilegeLevel: "admin",
      },
      search: "",
      businessPortalUsers: [],
      unsubscribeBusinessPortalUsersSnapshot: null,
    };
  },
  props: {
    businessProfileId: { type: String, default: "" },
    selectedBusinessProfileId: { type: String, default: "" },
    businessProfile: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  created() {
    this.unsubscribeBusinessPortalUsersSnapshot = onSnapshot(
        queryBusinessPortalAccessCollection(where("businessProfileId", "==", this.businessProfileId)),
        (querySnapshot) => {
        this.businessPortalUsers = [];
        querySnapshot.forEach((doc) => {
          this.businessPortalUsers.push({
            documentId: doc.id,
            name: doc.data().firstName + " " + doc.data().lastName,
            firstName: doc.data().firstName,
            lastName: doc.data().lastName,
            email: doc.data().email,
            privilegeLevel: doc.data().privilegeLevel,
            status: doc.data().status,
            uid: doc.data().uid || "",
          });
        });
        //Sort the this.businessPortalUsers array
        console.log("this.businessPortalUsers: ", this.businessPortalUsers);
      });
  },
  destroyed() {
    this.unsubscribeBusinessPortalUsersSnapshot();
  },
  computed: {
    ...mapGetters(["loggedInUsersUid", "currentPermission", "isSuperUser"]),
    headers() {
      let value = [
        {
          text: "User",
          align: "start",
          value: "user",
        },
        { text: "Status", value: "status", align: "center" },
        { text: "Privilege Level", value: "privilegeLevel" },
      ];
      if (
        this.currentPermission.privilegeLevel == "admin" ||
        this.isSuperUser
      ) {
        value.push({
          text: "Actions",
          value: "actions",
          align: "center",
        });
      }
      return value;
    },
    emailRules() {
      return [
        (v) => {
          let i = 0;
          for (i = 0; i < this.businessPortalUsers.length; i++) {
            if (
              this.businessPortalUsers[i].email.toUpperCase() == v.toUpperCase()
            )
              return `Already has access to this business profile`;
          }
          return true;
        },
        (v) => !!v || "This field is required",
        (v) => /.+@.+\..+/.test(v) || "Invalid email",
      ];
    },
  },
  components: {
    UserAvatar,
  },
  methods: {
    getPrivilegeLevelDiaplyText(privilegeLevelValue) {
      let i = 0;
      for (i = 0; i < this.privilegeLevelOptions.length; i++) {
        if (this.privilegeLevelOptions[i].value == privilegeLevelValue)
          return this.privilegeLevelOptions[i].text;
      }
      return privilegeLevelValue;
    },
    handleInviteNewClick() {
      this.resetInvitee();
      this.$refs.addEditAccessForm.resetValidation();
      this.selectedBusinessPortalUser.privilegeLevel = "admin";
      this.addEditDialog = true;
    },
    resetInvitee() {
      this.selectedBusinessPortalUser = {
        documentId: "",
        firstName: "",
        lastName: "",
        email: "",
        privilegeLevel: "admin",
      };
    },
    async sendInvitation() {
      if (this.$refs.addEditAccessForm.validate()) {
        try {
          this.addEditDialog = false;
          //If the email belongs to an existing Pappyon user: Get the uid associated with this email
          let selectedBusinessPortalUsersUid = "";
          let querySnapshot = await getQueryUsersCollection(where("email", "==", this.selectedBusinessPortalUser.email));
          querySnapshot.forEach(
            (doc) => (selectedBusinessPortalUsersUid = doc.id)
          );
          //Add a new document in the BusinessPortalAccess collection
          let newlyAddedDocRef = await
            addBusinessPortalAccessDoc({
              firstName: this.selectedBusinessPortalUser.firstName,
              lastName: this.selectedBusinessPortalUser.lastName,
              email: this.selectedBusinessPortalUser.email.toLowerCase(),
              businessProfileId: this.businessProfileId,
              status:
                selectedBusinessPortalUsersUid == "" ? "invited" : "active",
              privilegeLevel: this.selectedBusinessPortalUser.privilegeLevel,
              uid: selectedBusinessPortalUsersUid,
              businessName: this.businessProfile.businessName,
              country: this.businessProfile.country,
            });
          this.selectedBusinessPortalUser.documentId = newlyAddedDocRef.id;
          //Send an invitation email
          if (selectedBusinessPortalUsersUid == "") {
            //Send a new user an invitation email
            this.sendNewUserInvitation();
          } else {
            //send existing user invitation email
            this.sendExistingUserInvitation();
          }
        } catch (error) {
          console.log("In else");
          console.log("Error while sending invitation: " + error);
        }
      }
    },
    sendNewUserInvitation() {
      console.log("In sendNewUserInvitation");
      let firstName = this.selectedBusinessPortalUser.firstName;
      this.snackbarText = `Sending ${firstName} an invite...`;
      this.snackbarTimeout = -1;
      this.snackbar = true;

      const sendBusinessPortalAccessInvitation = getHttpsCallable("sendBusinessPortalAccessInvitation");
      sendBusinessPortalAccessInvitation({
        email: this.selectedBusinessPortalUser.email,
        firstName: this.selectedBusinessPortalUser.firstName,
        businessName: this.businessProfile.businessName,
        buttonUrl: `https://business.pappyon.com/portalAccessInvitation/${this.selectedBusinessPortalUser.documentId}`,
      })
        .then(async (result) => {
          //The cloud function was executed
          if (result.data.errorInfo) {
            //Encountered an error
            console.log("In the client then error block");
            console.log("Error: " + result.data.errorInfo.message);
          } else {
            console.log(result.data);
          }
          this.snackbarText = "Invite sent successfully!";
          this.snackbarTimeout = 3000;
        })
        .catch((error) => {
          console.log("In the client catch");
          console.log(error.message);
          this.snackbarText = "Something went wrong. Please try again.";
          this.snackbarTimeout = 3000;
        });
    },
    sendExistingUserInvitation() {
      console.log("In sendExistingUserInvitation");
      let firstName = this.selectedBusinessPortalUser.firstName;
      this.snackbarText = `Sending ${firstName} an invite...`;
      this.snackbarTimeout = -1;
      this.snackbar = true;

      const sendBusinessPortalAccessInvitation = getHttpsCallable("sendBusinessPortalAccessInvitation");
      console.log("selectedBusinessProfileId: ");
      console.log(this.selectedBusinessProfileId);
      sendBusinessPortalAccessInvitation({
        email: this.selectedBusinessPortalUser.email,
        firstName: this.selectedBusinessPortalUser.firstName,
        businessName: this.businessProfile.businessName,
        buttonUrl:
          "https://business.pappyon.com/businessAccounts?switchToBusinessProfileId=" +
          encodeURIComponent(this.selectedBusinessProfileId),
      })
        .then(async (result) => {
          //The cloud function was executed
          if (result.data.errorInfo) {
            //Encountered an error
            console.log("In the client then error block");
            console.log("Error: " + result.data.errorInfo.message);
          } else {
            console.log(result.data);
          }
          this.snackbarText = "Invite sent successfully!";
          this.snackbarTimeout = 3000;
        })
        .catch((error) => {
          console.log("In the client catch");
          console.log(error.message);
          this.snackbarText = "Something went wrong. Please try again.";
          this.snackbarTimeout = 3000;
        });
    },
    handleRemoveClick(businessPortalUser) {
      this.selectedBusinessPortalUser = businessPortalUser;
      this.removeBusinessPortalUserDialog = true;
    },
    handleEditClick(businessPortalUser) {
      this.selectedBusinessPortalUser = businessPortalUser;
      this.$refs.addEditAccessForm.resetValidation();
      this.addEditDialog = true;
    },
    async cancelInvitation(businessPortalUser) {
      this.selectedBusinessPortalUser = businessPortalUser;
      await this.removeBusinessPortalUser();
    },
    async removeBusinessPortalUser() {
      try {
        await deleteBusinessPortalAccessDoc(this.selectedBusinessPortalUser.documentId);
      } catch (error) {
        console.log(error);
      }
      this.removeBusinessPortalUserDialog = false;
    },
    async updateBusinessPortalAccessDetails() {
      try {
        await updateBusinessPortalAccessDoc(this.selectedBusinessPortalUser.documentId, {
            firstName: this.selectedBusinessPortalUser.firstName,
            lastName: this.selectedBusinessPortalUser.lastName,
            privilegeLevel: this.selectedBusinessPortalUser.privilegeLevel,
          });
      } catch (error) {
        console.log(error);
      }
      this.addEditDialog = false;
    },
    async updateBusinessPortalAccessStatus(documentId, status) {
      try {
        await updateBusinessPortalAccessDoc(documentId, {
            status: status,
          });
      } catch (error) {
        console.log(error);
      }
    },
    destroyBusinessPortalAccessSnapshot() {
      console.log("destroy bp snapshot");
      this.unsubscribeBusinessPortalUsersSnapshot();
    },
  },
};
</script>
<style scoped>
/* .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: #10163f !important;
} */
</style>
